<nb-actions size="small">
    <nb-action
        class="control-item"
        nbTooltip="Open Release Folder Location">
        @if (showReleaseFolderButton) {
            <button
                nbButton
                status="primary"
                size="small"
                (click)="showFolderClick()">
                <nb-icon
                    class="text-white"
                    icon="folder-outline"></nb-icon>
                Show Release Folder
            </button>
        }
    </nb-action>
</nb-actions>
